import ReactPaginate from 'react-paginate';
import { useDict } from '../contexts/LanguageContext';

const Paginate = (props) => {
    const dict = useDict();

    return (
        <div className="react-paginate">
            <ReactPaginate
                nextLabel={dict.next}
                previousLabel={dict.prev}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                renderOnZeroPageCount={null}
                {...props}
            />
        </div>
    );
};

export default Paginate;
